/* eslint-disable no-empty-pattern */
import Vue from "vue";
import { instance } from "@/config/index.js";

const initialState = () => ({
  phone: null,
  session: null,
  status: null,

  dialing: false,
  paused: false,

  startCallTick: false,
  stopCallTick: false,
  userInteractionTick: false,
  singleCallFallbackTick: false,

  userCredentials: null,
  rowId: null,
  singleOpportunityId: null,

  showBar: false,
  isAudioReady: false,

  external_phone_is_singular_call: false,
});

const getters = {
  getPhoneConnection(state) {
    return state.phone;
  },

  getSession(state) {
    return state.session;
  },

  getPhoneStatus(state) {
    return state.status;
  },

  getIsDialing(state) {
    return state.dialing;
  },

  getIsPaused(state) {
    return state.paused;
  },

  getIsReadyAudios(state) {
    return state.isAudioReady;
  },

  getStartCallTick(state) {
    return state.startCallTick;
  },

  getStopCallTick(state) {
    return state.stopCallTick;
  },

  getUserInteractionTick(state) {
    return state.userInteractionTick;
  },

  getSingleCallFallbackTick(state) {
    return state.singleCallFallbackTick;
  },

  getUserCredentials(state) {
    return state.userCredentials;
  },

  getRowId(state) {
    return state.rowId;
  },

  getSingleOpportunityId(state) {
    return state.singleOpportunityId;
  },

  getIsSingularCall(state) {
    return state.external_phone_is_singular_call;
  },
};

const actions = {
  resetStore({ commit }) {
    commit("RESET_STATE");
  },

  endRowViaStore({ commit, dispatch }, rowId) {
    dispatch("rowStopEvent", rowId);

    commit("CHANGE_IS_DIALING", false);
  },

  getSipCredentials({}, userId) {
    const workspaceId = localStorage.getItem("currentWorkspace");

    return new Promise((resolve, reject) => {
      instance()
        .get(`/workspaces/${workspaceId}/users/${userId}`)
        .then((response) => resolve(response))
        .catch((err) => reject(err));
    });
  },

  createSipRow({}, rowData) {
    const workspaceId = localStorage.getItem("currentWorkspace");

    const postUrl = `/workspaces/${workspaceId}/batch-calls`;

    return new Promise((resolve, reject) => {
      instance()
        .post(postUrl, rowData)
        .then((response) => resolve(response))
        .catch((err) => reject(err));
    });
  },

  rowStartEvent({}, rowId) {
    const workspaceId = localStorage.getItem("currentWorkspace");

    const postUrl = `/workspaces/${workspaceId}/batch-calls/${rowId}/start`;

    return new Promise((resolve, reject) => {
      instance()
        .post(postUrl)
        .then((response) => resolve(response))
        .catch((err) => reject(err));
    });
  },

  rowPauseEvent({}, rowId) {
    const workspaceId = localStorage.getItem("currentWorkspace");

    const postUrl = `/workspaces/${workspaceId}/batch-calls/${rowId}/pause`;

    return new Promise((resolve, reject) => {
      instance()
        .post(postUrl)
        .then((response) => resolve(response))
        .catch((err) => reject(err));
    });
  },

  rowStopEvent({}, rowId) {
    const workspaceId = localStorage.getItem("currentWorkspace");

    const postUrl = `/workspaces/${workspaceId}/batch-calls/${rowId}/stop`;

    return new Promise((resolve, reject) => {
      instance()
        .post(postUrl)
        .then((response) => resolve(response))
        .catch((err) => reject(err));
    });
  },

  singleVoipCall({}, callData) {
    const workspaceId = localStorage.getItem("currentWorkspace");

    const postUrl = `/workspaces/${workspaceId}/opportunity-calls`;

    return new Promise((resolve, reject) => {
      instance()
        .post(postUrl, callData)
        .then((response) => resolve(response))
        .catch((err) => reject(err));
    });
  },
};

const mutations = {
  CHANGE_SIP(state, sipConnection) {
    state.phone = sipConnection;
  },

  CHANGE_SESSION(state, session) {
    state.session = session;
  },

  CHANGE_STATUS(state, status) {
    state.status = status;
  },

  CHANGE_IS_DIALING(state, boolVar) {
    state.dialing = boolVar;
  },

  CHANGE_IS_PAUSED(state, boolVar) {
    state.paused = boolVar;
  },

  CHANGE_USER_CREDENTIALS(state, credentials) {
    state.userCredentials = credentials;
  },

  CHANGE_ROW_ID(state, rowId) {
    state.rowId = rowId;
  },

  CHANGE_SINGLE_OPPORTUNITY_ID(state, singleOpportunityId) {
    state.singleOpportunityId = singleOpportunityId;
  },

  CHANGE_SHOW_BAR(state, showBar) {
    state.showBar = showBar;
  },

  CHANGE_AUDIO_READY(state, boolVar) {
    state.isAudioReady = boolVar;
  },

  CHANGE_IS_SINGULAR_CALL(state, boolVar) {
    state.external_phone_is_singular_call = boolVar;
  },

  TRIGGER_START_CALLS(state) {
    state.startCallTick = !state.startCallTick;
  },

  TRIGGER_END_CALL(state) {
    state.stopCallTick = !state.stopCallTick;
  },

  TRIGGER_USER_INTERACTION(state) {
    state.userInteractionTick = !state.userInteractionTick;
  },

  TRIGGER_SINGLE_CALL_FALLBACK(state) {
    state.singleCallFallbackTick = !state.singleCallFallbackTick;
  },

  RESET_STATE(state) {
    const initial = initialState();

    Object.keys(initial).forEach((key) => {
      state[key] = initial[key];
    });
  },
};

export default {
  namespaced: true,
  state: initialState(),
  mutations,
  actions,
  getters,
};
